export default "__VITE_ASSET__CF1TkpGZ__"